// =============================================================================
// app/src/pessoal/cliente.ts — o cliente do BANCO PESSOAL (Meu dinheiro).
//
// É um segundo supabase-js, e só fala com o PostgREST do banco `pessoal`
// (api.…/pessoal/rest/v1, ADR-008). O login é o MESMO da loja: o token que vai
// em cada chamada é o da sessão do cliente principal (lib/supabase.ts), lido na
// hora pela opção `accessToken`.
//
// POR QUE `accessToken` E NÃO UM SEGUNDO LOGIN: com ela o supabase-js nem cria
// o módulo de autenticação deste cliente (acessar `pessoal.auth` estoura, de
// propósito). O dono da sessão continua sendo UM só — quem renova o token, quem
// sai e quem entra é o cliente principal —, e não existem dois relógios de
// renovação brigando pelo mesmo refresh token no localStorage.
//
// A FRONTEIRA: só o código de src/pessoal/ importa este arquivo. O resto do app
// fala com o Meu dinheiro pelas funções de ./api.ts, e o teste
// src/lib/fronteiraPessoal.test.ts reprova quem importar isto de fora.
// =============================================================================
import { createClient } from '@supabase/supabase-js';
import { configuracaoDaApi, supabase } from '../lib/supabase';

/** A base da API com a barra no fim: `new URL('pessoal/', base)` sem ela
 *  trocaria o último pedaço do caminho em vez de acrescentar. */
function comBarraNoFim(url: string): string {
  return url.endsWith('/') ? url : `${url}/`;
}

/** `https://api.…/pessoal/` — o supabase-js acrescenta `rest/v1` a isto. */
export const URL_DO_BANCO_PESSOAL = new URL('pessoal/', comBarraNoFim(configuracaoDaApi.url)).href;

export const pessoal = createClient(URL_DO_BANCO_PESSOAL, configuracaoDaApi.chaveAnon, {
  // Sem sessão, null: o supabase-js então manda a chave anônima, e o PostgREST
  // pessoal — que não tem papel `anon` — recusa. É o comportamento certo.
  accessToken: async () => (await supabase.auth.getSession()).data.session?.access_token ?? null,
});
